import React, { useEffect, useState } from "react";
import axios from "axios";

export default function AdministrarResidentes() {
  const [residentes, setResidentes] = useState([]);
  const [nuevoNombre, setNuevoNombre] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [nombreEditado, setNombreEditado] = useState("");

  const token = localStorage.getItem("token");

  const fetchResidentes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/residentes`, {
        headers: { Authorization: token },
      });
      setResidentes(res.data);
    } catch (err) {
      console.error("Error cargando residentes", err);
    }
  };

  const agregarResidente = async () => {
    if (!nuevoNombre.trim()) return;
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/residentes`,
        { nombre: nuevoNombre },
        { headers: { Authorization: token } }
      );
      setNuevoNombre("");
      fetchResidentes();
    } catch (err) {
      alert("Error agregando residente");
    }
  };

  const guardarEdicion = async (id) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/residentes/${id}`,
        { nombre: nombreEditado },
        { headers: { Authorization: token } }
      );
      setEditandoId(null);
      setNombreEditado("");
      fetchResidentes();
    } catch (err) {
      alert("Error actualizando residente");
    }
  };

  const eliminarResidente = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar este residente?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/residentes/${id}`, {
        headers: { Authorization: token },
      });
      fetchResidentes();
    } catch (err) {
      alert("Error eliminando residente");
    }
  };

  useEffect(() => {
    fetchResidentes();
  }, []);

  return (
    <div className="p-3">
      <h4>Administración de Residentes</h4>

      <div className="input-group mb-3">
        <input
          className="form-control"
          placeholder="Nuevo residente"
          value={nuevoNombre}
          onChange={(e) => setNuevoNombre(e.target.value)}
        />
        <button className="btn btn-primary" onClick={agregarResidente}>
          Agregar
        </button>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {residentes.map((r) => (
            <tr key={r._id}>
              <td>
                {editandoId === r._id ? (
                  <input
                    value={nombreEditado}
                    className="form-control"
                    onChange={(e) => setNombreEditado(e.target.value)}
                  />
                ) : (
                  r.nombre
                )}
              </td>
              <td>
                {editandoId === r._id ? (
                  <>
                    <button
                      className="btn btn-success btn-sm me-2"
                      onClick={() => guardarEdicion(r._id)}
                    >
                      Guardar
                    </button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        setEditandoId(null);
                        setNombreEditado("");
                      }}
                    >
                      Cancelar
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => {
                        setEditandoId(r._id);
                        setNombreEditado(r.nombre);
                      }}
                    >
                      Editar
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => eliminarResidente(r._id)}
                    >
                      Eliminar
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
